
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabservicemahapemidc() {



const cardData = {
  keyword: 'Cab Service Mahape MIDC',
  heading: 'eTravo:  Corporate Cab Services in Mahape MIDC',
  headingDescription: 'eTravo offers comprehensive corporate cab services in Mahape MIDC, catering to the transportation needs of businesses and employees in this fast-growing industrial and commercial hub. From daily employee commutes to executive travel and client transfers, our services focus on reliability, safety, and comfort. Equipped with GPS-enabled vehicles and professional chauffeurs, eTravo ensures punctual and customizable transport solutions for companies of all sizes operating in Mahape MIDC and the surrounding Navi Mumbai area.',

  top: 'Key Industrial and Commercial Landmarks in Mahape MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Reliance Jio Infocomm Ltd',
      description: 'One of the largest telecom operators in India, with its headquarters and key facilities in Mahape. eTravo provides dependable cab services for employees and executives commuting daily to Reliance Jio offices.'
    },
    {
      title: 'Tata Consultancy Services (TCS) Mahape',
      description: 'A major IT services campus hosting thousands of employees. Our cab services ensure timely and comfortable transportation for TCS staff across shifts.'
    },
    {
      title: 'Mahape Industrial Park',
      description: 'An industrial zone hosting a variety of manufacturing and logistics companies. eTravo supports employee transport and business travel within this busy industrial area.'
    },
    {
      title: 'Navi Mumbai SEZ',
      description: 'A Special Economic Zone with a mix of IT, manufacturing, and service sector companies. We offer dedicated shuttle and corporate cab services tailored for SEZ enterprises.'
    },
    {
      title: 'MSEZ Administrative Office',
      description: 'The administrative hub for Mahape SEZ. Our cab services facilitate smooth travel for government officials and SEZ personnel.'
    },
    {
      title: 'Technip India Ltd',
      description: 'A global engineering company operating in Mahape MIDC. eTravo’s corporate transport solutions support their staff commuting needs and client visits.'
    },
    {
      title: 'Mahape Railway Station',
      description: 'A vital transit point connecting Mahape with Mumbai and Navi Mumbai. Our cab services provide convenient last-mile connectivity for employees and visitors.'
    },
    {
      title: 'Larsen & Toubro (L&T) Mahape',
      description: 'An engineering and construction giant with operations here. We offer reliable staff transportation solutions customized to L&T’s operational shifts.'
    },
    {
      title: 'Mahape Bus Depot',
      description: 'A key bus terminus serving industrial and commercial commuters. eTravo’s cabs complement public transport by offering door-to-door corporate travel.'
    },
    {
      title: 'Navi Mumbai Industrial Area',
      description: 'Adjacent industrial zones where eTravo also provides flexible and scalable corporate cab services for employee mobility and business logistics.'
    }
  ],

  services: [
    {
      name: 'Mahape MIDC Corporate Cab Rentals',
      description: 'Customizable cab rental packages designed to meet the unique needs of businesses operating in Mahape MIDC, offering flexible plans and scalable fleet options.'
    },
    {
      name: 'Employee Transport Cab Mahape',
      description: 'Daily employee shuttle services with guaranteed punctuality, professional drivers, and well-maintained, GPS-enabled vehicles for secure and comfortable commutes.'
    },
    {
      name: 'Business Cab Services Mahape MIDC',
      description: 'Corporate cab solutions for business travel including client visits, inter-office transfers, and industrial site trips with a variety of vehicle options.'
    },
    {
      name: 'Corporate Staff Cabs Mahape',
      description: 'Efficient staff transportation solutions with multi-stop routes, shift-based scheduling, and real-time tracking for operational excellence.'
    },
    {
      name: 'Reliable Corporate Cab Service Mahape MIDC',
      description: 'Trusted by numerous companies in Mahape for dependable service, clean vehicles, professional drivers, and timely arrivals for all corporate transport needs.'
    },
    {
      name: 'AC Corporate Cabs Mahape',
      description: 'All vehicles in the fleet are air-conditioned and sanitized regularly, ensuring a comfortable travel environment suitable for the Mumbai-Navi Mumbai climate.'
    },
    {
      name: 'Staff Pickup and Drop Cab Mahape',
      description: 'Round-the-clock staff pickup and drop services aligned with company shift timings and operational requirements, maximizing employee convenience and productivity.'
    },
    {
      name: 'Affordable Business Cab Rentals Mahape MIDC',
      description: 'Cost-effective and transparent corporate cab rental solutions with flexible billing, , and monthly contracts for companies of all sizes.'
    },
    {
      name: 'Executive Cab Services Mahape',
      description: 'Premium executive transportation featuring luxury vehicles, professional chauffeurs, and personalized scheduling for VIPs and business leaders.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Mahape MIDC',
      description: 'Comprehensive monthly rental plans covering daily staff transport, business trips, and corporate events, supported by advanced fleet management.'
    },
    {
      name: 'Industrial Area Employee Transport Mahape',
      description: 'Complete transport coordination for industrial area employees with optimized routes, shift compliance, and safety measures.'
    },
    {
      name: 'Corporate Client Cabs Mahape MIDC',
      description: 'Professional and comfortable transportation for visiting clients and business partners to create a positive corporate impression.'
    },
    {
      name: 'Business Meeting Cabs Mahape',
      description: 'On-demand, reliable cab services tailored to meet business meeting schedules and site visits within Mahape MIDC and nearby areas.'
    },
    {
      name: 'Mahape Industrial Area Cab Hire',
      description: 'Flexible cab hire services for corporate staff commutes, business functions, and urgent travel needs, with scalable vehicle availability.'
    },
    {
      name: 'Corporate Shuttle Cabs Mahape MIDC',
      description: 'Efficient shuttle services designed for group transport, facilitating seamless connectivity between corporate offices, industrial parks, and transit points.'
    }
  ],

  tableData: [
    ['Mahape MIDC Corporate Cab Rentals', 'Employee Transport Cab Mahape'],
    ['Business Cab Services Mahape MIDC', 'Corporate Staff Cabs Mahape'],
    ['Reliable Corporate Cab Service Mahape MIDC', 'AC Corporate Cabs Mahape'],
    ['Staff Pickup and Drop Cab Mahape', 'Affordable Business Cab Rentals Mahape MIDC'],
    ['Executive Cab Services Mahape', 'Monthly Corporate Cab Rentals Mahape MIDC'],
    ['Industrial Area Employee Transport Mahape', 'Corporate Client Cabs Mahape MIDC'],
    ['Business Meeting Cabs Mahape', 'Mahape Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Mahape MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Customized Corporate Cab Solutions for Mahape MIDC",
        "WhyChoosedescription": "eTravo offers specialized cab services tailored to the specific transportation needs of businesses in Mahape Industrial Area MIDC. Our solutions ensure timely and efficient commutes for employees, helping companies maintain productivity and reduce commute-related stress."
    },
    {
        "WhyChooseheading": "Extensive Fleet Catering to Diverse Corporate Requirements",
        "WhyChoosedescription": "Our fleet includes a variety of vehicles such as sedans, SUVs, and MUVs, allowing companies to select options that best fit their daily employee commutes, client visits, or inter-office travel within Mahape and surrounding areas."
    },
    {
        "WhyChooseheading": "Experienced Drivers Well-Acquainted with Mahape MIDC Routes",
        "WhyChoosedescription": "Our drivers have thorough knowledge of Mahape MIDC and neighboring regions, enabling them to navigate efficiently, adhere to schedules, and minimize delays, ensuring reliable service for corporate clients."
    },
    {
        "WhyChooseheading": "Flexible Booking Solutions to Suit Corporate Schedules",
        "WhyChoosedescription": "We provide flexible booking options including on-demand rides, pre-scheduled pickups, and long-term contracts, allowing businesses to manage their transportation needs conveniently and adapt to changing employee shifts."
    },
    {
        "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Safety and Transparency",
        "WhyChoosedescription": "All cabs are equipped with GPS tracking technology, enabling corporate clients to monitor rides in real time, enhancing passenger safety and providing complete transparency during every trip."
    },
    {
        "WhyChooseheading": "Transparent Billing with Comprehensive Invoices",
        "WhyChoosedescription": "Our billing process is straightforward and detailed, offering clear invoices with trip summaries and fare breakdowns to simplify expense management and reimbursement for corporate finance teams."
    },
    {
        "WhyChooseheading": "Strict Safety and Hygiene Protocols to Ensure Passenger Wellbeing",
        "WhyChoosedescription": "In compliance with health guidelines, vehicles undergo regular sanitization and drivers follow stringent hygiene measures, guaranteeing a safe and comfortable travel experience for all passengers."
    },
    {
        "WhyChooseheading": "Dedicated Account Management for Corporate Clients",
        "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager to assist with bookings, handle inquiries, and provide personalized support, ensuring smooth and efficient transportation management."
    }
]
}

const faqData = [
    [
        {
            question: "Which areas are covered by your corporate cab service in Mahape MIDC?",
            answer: "Our service area includes Mahape Industrial Area MIDC and nearby business districts like Navi Mumbai SEZ, Ghansoli, and Airoli."
        },
        {
            question: "Can we schedule regular rides for employees in Mahape MIDC?",
            answer: "Yes, we offer recurring ride scheduling options to provide consistent and reliable transportation for your employees."
        },
        {
            question: "Do you offer monthly billing and invoicing for corporate clients?",
            answer: "Absolutely. We provide monthly billing cycles with detailed invoices to facilitate easy expense tracking and reimbursement."
        },
        {
            question: "Are your drivers trained to maintain professionalism and corporate etiquette?",
            answer: "Yes, all our drivers undergo comprehensive training to ensure professionalism, courtesy, and adherence to corporate standards."
        },
        {
            question: "How do you ensure the safety and hygiene of passengers during rides?",
            answer: "We utilize real-time GPS tracking, conduct regular vehicle maintenance, and follow strict hygiene protocols including sanitization and mask mandates."
        },
        {
            question: "Is dedicated support available for corporate clients in Mahape MIDC?",
            answer: "Yes, corporate clients have access to a dedicated support team and account managers for timely assistance and personalized service."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Karan Mehta",
        designation: "Operations Manager, TechWave Solutions",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s cab service in Mahape MIDC has streamlined our employee transportation, offering punctuality and excellent customer support.”"
    },
    {
        name: "Ms. Nisha Kapoor",
        designation: "HR Executive, Nova Industries",
        rating: [1, 1, 1, 1, 1],
        text: "“The safety protocols and flexible booking options provided by eTravo make them our trusted partner for corporate transportation in Mahape.”"
    }
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service Mahape MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-mahape-midc.jpg",
  "description": "Reliable cab service in Mahape MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable AC corporate cabs with professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7999"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-mahape-midc"
  }
};








    return (
        <div>
<Helmet>
  <title>Cab Service Mahape MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Mahape MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabservicemahapemidc;